import axios from 'axios'

/**
 *
 * @param {object} payload add language payload
 * @returns
 */
export const saveCalibrationDetailsToDB = async (payload) => {
  const response = await axios.post('candidates/movement-detections', payload)
  return response
}

/**
 *
 * @param {object} payload add language payload
 * @returns
 */
export const getCalibrationDetailsToDB = async (contestId, candidateId) => {
  const response = await axios.get(
    `candidates/movement-detections?contestId=${contestId}&candidateId=${candidateId}`
  )

  return response
}
